import moment from 'moment'

const countAndPluralize = (text, value) => `${value} ${text}${Number(value) === 1 ? '' : 's'}`

export const getValueTextFormatter = ({
  formatByTime,
  formatByDuration,
  isMilitaryTime,
  currencySymbol,
  plusSymbol,
  max,
}) => (value) => {
  if (formatByTime) {
    return isMilitaryTime ? moment(value).format(`dddd HH:mm`) : moment(value).format(`dddd h:mm a`)
  } else if (formatByDuration) {
    const duration = moment.duration(value)
    const hours = Math.floor(duration.asHours())
    const minutes = moment.utc(duration.asMilliseconds()).format('m')
    return `${countAndPluralize('hour', hours)} and ${countAndPluralize('minute', minutes)}`
  }
  return `${currencySymbol || ''}${value}${plusSymbol && value === max ? plusSymbol : ''}`
}

const prependFilterName = (filterName, label) => `${filterName ? `${filterName}, ` : ''}${label}`

export const getAriaLabels = ({ formatByTime, formatByDuration, currencySymbol, oneWay }, filterName) => {
  if (formatByTime) {
    return [prependFilterName(filterName, 'Earliest time'), prependFilterName(filterName, 'Latest time')]
  } else if (formatByDuration) {
    return [prependFilterName(filterName, 'Maximum duration')]
  } else if (currencySymbol) {
    return [prependFilterName(filterName, 'Lowest price'), prependFilterName(filterName, 'Highest price')]
  }
  return oneWay
    ? [filterName]
    : [prependFilterName(filterName, 'Minimum'), prependFilterName(filterName, 'Maximum')]
}
